import React from "react";
import { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import translate from "../../../i18n/translate";
import { useHistory, useLocation } from "react-router-dom";
import {
  getJawwalMin,
  getChargeJawwal,
  getRnewJawwalMin,
  getNotRnewJawwalMin,
} from "../../../actions/companiesAction";
import SubNav from "./SubNav";
import Spinner from "../../ui/spinner/Spinner";
import Selected from "./Selected";
import JawalMinCard from "./JawalMinCard";
import CompaniesNav from "../../common/CompaniesNav";
import logo from "../../../assests/images/bundles/jawwal/banner.jpg";
import CompaniesSkeleton from "../../homePage/CompaniesSkeleton";
import { jsonParser } from "shared/utils/ppUtils";

const JawwalMin = ({
  jawalMinReniew,
  jawalMinNotReniew,
  getJawwalMin,
  JawwalMinLoading,
  isDarktheme,
}) => {
  const history = useHistory().location.pathname;
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [isRenew, setIsRenew] = useState(true);
  const [isNotRenew, setIsNotRenew] = useState(false);
  // var [amount, setAmount] = useState("");
  const [selected, setSelected] = useState("");
  const [jawwal3g, setJawwal3g] = useState("");
  const [jawwalRom, setJawwalRom] = useState("");
  const [credit, setCredit] = useState("");
  const [creditQueue, setCreditQueue] = useState([]);
  const [columnStyle, setColumnStyle] = useState("col-lg-3 col-md-4 col-sm-4");
  const collapseRef = useRef([]);
  const listRefNotRen = useRef(null);
  const listRefRen = useRef(null);
  const [plus, setPlus] = useState("");

  let mobileNo =
    history.split("/")[3].slice(0, 3) +
    "-" +
    history.split("/")[3].slice(3, 6) +
    "-" +
    history.split("/")[3].slice(6, 10);
  let routerMobileNo = history.split("/")[3];

  const handleCreditQueueChange = (queue) => {
    setCreditQueue(queue || []);
    setCredit(queue?.[queue.length - 1] || "");
  };

  useEffect(() => {
    const handleSessionStorageChange = () => {
      document.title = "Jawwal Min | Phone Play";
      if (sessionStorage.JawwalMin) {
        setSelected(jsonParser(sessionStorage.JawwalMin));
        // setAmount((prev) => prev + parseFloat(selected.price));
      }
      if (sessionStorage.Jawwal3g) {
        setJawwal3g(jsonParser(sessionStorage.Jawwal3g));
      }
      // Load credit queue from sessionStorage
      if (sessionStorage.JawwalCreditQueue) {
        const parsedQueue = jsonParser(sessionStorage.JawwalCreditQueue);
        if (Array.isArray(parsedQueue) && parsedQueue.length) {
          handleCreditQueueChange(parsedQueue);
        }
      } else if (sessionStorage.JawwalCredit) {
        const parsedCredit = jsonParser(sessionStorage.JawwalCredit);
        if (parsedCredit) {
          handleCreditQueueChange([parsedCredit]);
        }
      } else {
        handleCreditQueueChange([]);
      }
      if (sessionStorage.JawwalRom) {
        setJawwalRom(jsonParser(sessionStorage.JawwalRom));
      }
      if (sessionStorage.JawwalPlus) {
        setPlus(jsonParser(sessionStorage.JawwalPlus));
      }
      refreshColumnStyle();
    };
    handleSessionStorageChange();

    document.addEventListener("click", handleClickOutside);
    window.addEventListener(
      "sessionStorageChanged",
      handleSessionStorageChange
    );

    return () => {
      document.removeEventListener("click", handleClickOutside);
      window.removeEventListener(
        "sessionStorageChanged",
        handleSessionStorageChange
      );
    };
    // eslint-disable-nex\t-line react-hooks/exhaustive-deps
  }, [mobileNo, history]);

  useEffect(() => {
    const path = location.pathname;
    const segments = path.split("/");
    const routerMobileNo = segments[3];

    if (routerMobileNo && routerMobileNo.length === 10) {
      const number = params.get("number") || routerMobileNo;

      getJawwalMin(number, false, isRenew);
    }
  }, [location.pathname, isRenew]);

  const handleClickOutside = (event) => {
    if (
      listRefNotRen.current &&
      !listRefNotRen.current.contains(event.target) &&
      listRefRen.current &&
      !listRefRen.current.contains(event.target)
    ) {
      collapseRef.current.forEach((item) => {
        item?.classList?.remove("show");
      });
    }
  };

  const onTypeClick = (item) => {
    if (item.active !== "1" && item.active?.toLowerCase() !== "true") {
      return;
    }
    sessionStorage.JawwalMin = JSON.stringify(item);
    document
      .getElementsByTagName("html")[0]
      .scrollIntoView({ behavior: "smooth" });

    setSelected(item);
  };
  const onRenewClick = () => {
    setIsRenew(true);
    setIsNotRenew(false);
  };
  const onNotRenewClick = () => {
    setIsNotRenew(true);
    setIsRenew(false);
  };

  const refreshClick = () => {
    getJawwalMin(mobileNo, true, isRenew);
  };

  const refreshColumnStyle = () => {
    switch (localStorage.size) {
      case "default":
        setColumnStyle("col-lg-3 col-md-4 col-sm-6 col-6");
        break;
      case "column3":
        setColumnStyle("col-lg-4 col-md-6 col-sm-6 col-6 card-lg");
        break;
      case "column4":
        setColumnStyle("col-lg-3 col-md-4 col-sm-6 col-6  card-md");
        break;
      case "column6":
        setColumnStyle("col-lg-2 col-md-2 col-sm-4 col-6 card-sm");
        break;
      default:
        setColumnStyle("col-lg-3 col-md-4 col-sm-6 col-6");
    }
  };
  let topDiv = null;

  return (
    <div ref={(ref) => (topDiv = ref)} className="mb-5">
      <div>
        <CompaniesNav
          providerId={window?.history?.state?.state?.provider_Id}
          title="Jawwal"
          logo={logo}
          mobile={routerMobileNo}
          onRefresh={refreshClick}
          actionWidth="300px"
          backLink="/company/jawwalNo"
        >
          <button
            type="button"
            className={`btn btn-light btn-md btn-renewable main-text border-info border-left px-1 ${
              isRenew ? "selected-btn" : ""
            }`}
            onClick={onRenewClick}
          >
            {translate("Renewable")}
          </button>
          <button
            type="button"
            className={`btn btn-light btn-md btn-renewable main-text border-info border-left px-1 ${
              isNotRenew ? "selected-btn" : ""
            }`}
            onClick={onNotRenewClick}
          >
            {translate("notRenew")}
          </button>
        </CompaniesNav>

        <div className="row">
          <div className="col-12">
            <SubNav mobile={history.split("/")[3]} />
          </div>
        </div>
      </div>
      <div className="position-relative">
        <Selected
          min={selected}
          setMin={setSelected}
          g3={jawwal3g}
          setg3={setJawwal3g}
          credit={credit}
          setCredit={setCredit}
          creditQueue={creditQueue}
          onCreditQueueChange={handleCreditQueueChange}
          rom={jawwalRom}
          setRom={setJawwalRom}
          setPlus={setPlus}
          plus={plus}
        />

        <hr
          className="mt-3"
          style={{
            border: "2px solid #42ace3",
            backgroundColor: "#42ace3",
            fontWeight: "bolder",
          }}
        />

        {(isRenew || !isNotRenew) && (
          <div
            className={`${
              isDarktheme ? "dark-card" : "card"
            } list-cards p-3 mt-4`}
            ref={listRefNotRen}
          >
            <div className="row">
              <h3 className="mb-4">{translate("Renewable")}</h3>
              {JawwalMinLoading &&
                [...Array(6)].map((e, i) => (
                  <CompaniesSkeleton
                    height={130}
                    columnStyle={columnStyle}
                    key={i}
                  />
                ))}
              {jawalMinReniew.length === 0 && !JawwalMinLoading ? (
                <div className="d-flex justify-content-center mt-3">
                  <h2 className="text-info">
                    {translate("No available bundles")}
                  </h2>
                </div>
              ) : (
                jawalMinReniew.map((item, index) => (
                  <JawalMinCard
                    isDarktheme={isDarktheme}
                    collapseRef={collapseRef}
                    key={index.toString()}
                    item={item}
                    onTypeClick={onTypeClick}
                    columnStyle={columnStyle}
                    index={index}
                  />
                ))
              )}
            </div>
          </div>
        )}

        {(isNotRenew || !isRenew) && (
          <div
            className={`${
              isDarktheme ? "dark-card" : "card"
            } list-cards p-3 mt-4`}
            ref={listRefRen}
          >
            <div className="row">
              <h3 className="mb-4">{translate("notRenew")}</h3>
              {JawwalMinLoading &&
                [...Array(6)].map((e, i) => (
                  <CompaniesSkeleton
                    height={130}
                    columnStyle={columnStyle}
                    key={i}
                  />
                ))}
              {jawalMinNotReniew.length === 0 && !JawwalMinLoading ? (
                <div className="d-flex justify-content-center mt-3">
                  <h2 className="text-info">
                    {translate("No available bundles")}
                  </h2>
                </div>
              ) : (
                jawalMinNotReniew.map((item, index) => (
                  <JawalMinCard
                    isDarktheme={isDarktheme}
                    collapseRef={collapseRef}
                    key={index.toString()}
                    item={item}
                    onTypeClick={onTypeClick}
                    columnStyle={columnStyle}
                    index={index + jawalMinReniew?.length}
                  />
                ))
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({
  auth,
  companies: { jawwalMin, jawalMinReniew, jawalMinNotReniew, JawwalMinLoading },
  darkTheme: { isDarktheme },
}) => ({
  auth,
  jawwalMin,
  jawalMinReniew,
  jawalMinNotReniew,
  JawwalMinLoading,
  isDarktheme,
});

export default connect(mapStateToProps, {
  getJawwalMin,
  getChargeJawwal,
  getRnewJawwalMin,
  getNotRnewJawwalMin,
})(JawwalMin);
